export default "__VITE_ASSET__c5b067e2__"